import React, { useState, useEffect } from "react";
import { Col, Label } from "reactstrap";
import { Skeleton } from "antd";
import { useTranslation } from "react-i18next";
import { SelectionListModal } from "../SelectionListModal";

const AddressBlock = ({
  items,
  isLoading,
  addressLabel,
  emptyMessage,
  primaryItemFormatter,
  renderItem,
  showModal,
  toggleModal,
  t,
}) => {
  const itemsCount = items.length;
  const primaryItem = itemsCount > 0 ? items[0] : null;
  const additionalItemsCount = Math.max(itemsCount - 1, 0);

  return (
    <>
      <Col xs={12} md={6} lg={4} className="mb-3">
        <Label className="fw-bold" htmlFor="selected_addresses">
          {addressLabel || t("ADDRESS_LABEL")}
        </Label>

        {isLoading ? (
          <Skeleton.Input active size="small" style={{ width: 200 }} />
        ) : itemsCount ? (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            href=""
            className="H6 d-flex align-items-center fw-bold cursor-pointer text-truncate"
            style={{ maxWidth: "240px" }}
            onClick={(e) => {
              e.preventDefault();
              toggleModal();
            }}
          >
            <span className="text-truncate">
              {primaryItemFormatter(primaryItem)}
            </span>
            {additionalItemsCount > 0 && (
              <small className="ms-1">+{additionalItemsCount}</small>
            )}
          </a>
        ) : (
          <span className="text-muted">
            {emptyMessage || t("NO_ITEMS_SELECTED", { defaultValue: "-" })}
          </span>
        )}
      </Col>
      <SelectionListModal
        isOpen={showModal}
        toggle={toggleModal}
        title={addressLabel || t("ADDRESS_LABEL")}
        items={items}
        emptyMessage={emptyMessage || t("NO_ITEMS_FOUND")}
        renderItem={renderItem}
      />
    </>
  );
};

export const AddressCapacityDisplay = ({
  items = [],
  madinahItems,
  madinahAddressLabel,
  isLoading = false,
  totalCapacity = 0,
  capacityLabel,
  addressLabel,
  emptyMessage,
  renderItem,
  primaryItemFormatter = (item) => item?.address || "-",
  pilgrimCount,
  pilgrimCountLabel,
}) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [showMadinaModal, setShowMadinaModal] = useState(false);

  const hasMadina = madinahAddressLabel != null && Array.isArray(madinahItems);

  useEffect(() => {
    if (showModal && items.length === 0) setShowModal(false);
  }, [showModal, items.length]);

  useEffect(() => {
    if (showMadinaModal && madinahItems?.length === 0) setShowMadinaModal(false);
  }, [showMadinaModal, madinahItems?.length]);

  return (
    <>
      <AddressBlock
        items={items}
        isLoading={isLoading}
        addressLabel={addressLabel}
        emptyMessage={emptyMessage}
        primaryItemFormatter={primaryItemFormatter}
        renderItem={renderItem}
        showModal={showModal}
        toggleModal={() => setShowModal((p) => !p)}
        t={t}
      />

      {hasMadina && (
        <AddressBlock
          items={madinahItems}
          isLoading={isLoading}
          addressLabel={madinahAddressLabel}
          emptyMessage={emptyMessage}
          primaryItemFormatter={primaryItemFormatter}
          renderItem={renderItem}
          showModal={showMadinaModal}
          toggleModal={() => setShowMadinaModal((p) => !p)}
          t={t}
        />
      )}

      <Col xs={12} md={6} lg={4} className="mb-3">
        <Label className="fw-bold d-block" htmlFor="total_capacity">
          {capacityLabel || t("TOTAL_PILGRIMS")}
        </Label>
        <span className="fw-bold mb-0">{totalCapacity || 0}</span>
      </Col>

      {pilgrimCountLabel != null && (
        <Col xs={12} md={6} lg={4} className="mb-3">
          <Label className="fw-bold d-block" htmlFor="pilgrim_count">
            {pilgrimCountLabel}
          </Label>
          {isLoading ? (
            <Skeleton.Input active size="small" style={{ width: 60 }} />
          ) : (
            <span className="fw-bold mb-0">{pilgrimCount ?? 0}</span>
          )}
        </Col>
      )}
    </>
  );
};
